import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-qb-expense-form',
  templateUrl: './qb-expense-form.component.html',
  styleUrls: ['./qb-expense-form.component.css'],
})
export class QbExpenseFormComponent {
  url: string = 'quickbooks';
  id!: string;
  syncToken!: string;
  form!: FormGroup;
  update = true;
  isLoading: boolean = false;
  vendors: Array<any> = [];
  categories: any[] = [];
  paymentAccounts: any[] = [];
  isPayroll: boolean = false;

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Quick Books',
      route: '/numbers/accounting',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Tax compliance',
      route: null,
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Invoices',
      route: '/numbers/accounting/invoices',
    },
    /* {
      label: '',
      value: 0,
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Bills',
      route: '/numbers/accounting/external',
    }, */
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      vendorId: [''], // VendorRef
      //vendorName: [''], // Opcional si lo tienes
      txnDate: ['', Validators.required], // Fecha del gasto
      lines: this.fb.array([], [Validators.required]),
      paymentType: ['Cash', Validators.required],
      paymentAccountId: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.getCategories();
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      this.syncToken = params['syncToken'];

      if (this.id) {
        this.getData();
        this.update = false;
      }
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.isLoading = true;
    this.dataService
      .getData(`${this.url}/expense/${this.id}`)
      .subscribe((response) => {
        //this.lineItems.clear();
        console.log('response get expense', response);

        const linesArray = this.form.get('lines') as FormArray;
        while (linesArray.length) {
          linesArray.removeAt(0);
        }
        //lineItemsArray.clear();

        (response?.data?.Line || []).forEach((line: any) => {
          const linesGroup = this.fb.group({
            id: line.Id,
            accountId:
              line.AccountBasedExpenseLineDetail?.AccountRef?.value || '',
            accountName:
              line.AccountBasedExpenseLineDetail?.AccountRef?.name || '',
            description: line.Description || '', // QuickBooks tiene un campo Description opcional
            amount: line.Amount || 0,
          });
          linesArray.push(linesGroup);
        });

        this.form.patchValue({
          //vendorId: response.data.EntityRef.value,
          //vendorName: response.data.vendorName,
          txnDate: response.data.TxnDate,
          paymentAccountId: response.data.AccountRef.value,
        });

        console.log('form', this.form.value);

        this.isLoading = false;
      });
  }

  createData(): void {
    this.isLoading = true;
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .postData(`${this.url}/createExpense`, formData)
      .subscribe((response) => {
        console.log('response add createPayment', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.isLoading = false;
          this.form.reset();
          this.router.navigateByUrl('/numbers/accounting/quickbooks/expenses');
          /* this.clearValidator();
          if (this.internal) {
            this.router.navigateByUrl('/numbers/accounting/internal');
          } else {
            this.router.navigateByUrl('/numbers/accounting/external');
          } */
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    this.isLoading = true;
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .putData(`${this.url}/editExpense/${this.id}/${this.syncToken}`, formData)
      .subscribe((response) => {
        console.log('response upd editPayment', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.isLoading = false;
          this.form.reset();
          this.router.navigateByUrl('/numbers/accounting/quickbooks/expenses');

          /* this.clearValidator();
          if (this.internal) {
            this.router.navigateByUrl('/numbers/accounting/internal');
          } else {
            this.router.navigateByUrl('/numbers/accounting/external');
          } */
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  enableUpdate() {
    this.update = !this.update;
  }

  get lines(): FormArray {
    return this.form.get('lines') as FormArray;
  }

  addLine() {
    this.lines.push(
      this.fb.group({
        accountId: ['', Validators.required], // AccountRef.value
        accountName: [''], // AccountRef.name
        description: [''], // Line.Description
        amount: ['', Validators.required],
      })
    );
  }

  removeLine(index: number) {
    this.lines.removeAt(index);
  }

 /*  setItem(index: number, id: string) {
    const item = this.categories.find((res) => res.Id === id);
    if (!item) return;
    console.log('item', item);

    const lineGroup = this.lines.at(index) as FormGroup;

    lineGroup.patchValue({
      accountId: item.Id,
    });

    console.log('form', this.form.value);
  } */

  getCategories() {
    this.isLoading = true;
    this.dataService.getData(`${this.url}/categories`).subscribe((response) => {
      console.log('categories', response);
      const allAccounts = response.data.QueryResponse.Account;

      // Filtrar cuentas de pago
      this.paymentAccounts = allAccounts.filter((acc) =>
        ['Bank', 'Cash', 'CreditCard'].includes(acc.AccountType)
      );

      console.log('paymentAccounts', this.paymentAccounts);
      // Filtrar categorías de gasto activas, excluyendo "Cost of Labor"
      const activeAccounts = allAccounts.filter((acc) => acc.Active !== false);
      this.categories = activeAccounts.filter(
        (acc) =>
          acc.AccountType?.toLowerCase() === 'expense' &&
          acc.Name?.toLowerCase() === 'uncategorized expense'.toLowerCase()
      );
      this.form.patchValue({
        paymentAccountId: this.paymentAccounts[0].Id,
      });

      this.lines.push(
        this.fb.group({
          accountId: [this.categories?.[0]?.Id || '', Validators.required],
          accountName: [this.categories?.[0]?.Name || ''],
          description: [''],
          amount: [''],
        })
      );

      this.isLoading = false;
    });
  }

  getvendors() {
    this.isLoading = true;
    this.dataService.getData(`${this.url}/vendors`).subscribe((response) => {
      console.log('vendors', response);
      this.vendors = response.data.QueryResponse.Vendor;
      this.isLoading = false;
    });
  }
}
